/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorNextDispensingSchedule,
  PharmacyCounselorNextDispensingScheduleFromJSON,
  PharmacyCounselorNextDispensingScheduleFromJSONTyped,
  PharmacyCounselorNextDispensingScheduleToJSON,
} from "./";

export const PharmacyCounselorRefillTypename = "PharmacyCounselorRefill" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorRefill
 */
export interface PharmacyCounselorRefill {
  /**
   *
   * @type {PharmacyCounselorNextDispensingSchedule}
   * @memberof PharmacyCounselorRefill
   */
  nextDispensingSchedule?: PharmacyCounselorNextDispensingSchedule;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorRefill
   */
  readonly __typename?: string;
}

export function PharmacyCounselorRefillFromJSON(json: any): PharmacyCounselorRefill {
  return PharmacyCounselorRefillFromJSONTyped(json, false);
}

export function PharmacyCounselorRefillFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyCounselorRefill {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorRefillTypename,

    nextDispensingSchedule: !exists(json, "next_dispensing_schedule")
      ? undefined
      : PharmacyCounselorNextDispensingScheduleFromJSON(json["next_dispensing_schedule"]),
  };
}

export function PharmacyCounselorRefillToJSON(object?: PharmacyCounselorRefill | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    next_dispensing_schedule: PharmacyCounselorNextDispensingScheduleToJSON(value.nextDispensingSchedule),
  };
}
